/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-alert */
import React from "react";
import mapIndicator from "icons/map-indicator.svg";

const Indicator = ({ onIndicatorClick  }) => {
  return (
    <>
      <img
        src={mapIndicator}
        className="cursor-pointer transform hover:scale-125"
        alt=""
        width={40}
        onClick={onIndicatorClick}
      />
    </>
  );
};

export default Indicator;
